// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ForSorting_checkbox__3HJ__","checkedCheckbox":"ForSorting_checkedCheckbox__3XBb6","sortingBox":"ForSorting_sortingBox__2nMG6"};